export default {
  notificationHandlers: [],
  notificationChannels: []
};